export default __webpack_public_path__ + "static/media/staking-item.8e88773a.png";